import { Component, OnInit, ViewChild } from '@angular/core'
import {
  BundleDefinitionODataService,
  IBundleDefinition,
  RefDiagnosisRelatedGroupODataService
} from '@exchange/domain/.'
import { ActivatedRoute, Router } from '@angular/router'
import { ToastrService } from 'ngx-toastr'
import {
  ActionButtonsColumnRendererComponent,
  BooleanFilterComponent,
  ConfirmModalComponent,
  GridWrapperComponent,
  LookupFilterComponent,
  Option
} from 'common-components'
import { BsModalService } from 'ngx-bootstrap/modal'

@Component({
  selector: 'app-bundle-definition-list',
  templateUrl: './bundle-definition-list.component.html',
  styleUrls: ['./bundle-definition-list.component.css'],
  standalone: false
})
export class BundleDefinitionListComponent implements OnInit {
  model: IBundleDefinition = null
  refDiagRelGrps: Option[] = []

  @ViewChild('grid', { static: true }) grid: GridWrapperComponent

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private odata: BundleDefinitionODataService,
    private refDiagRelGrpSvc: RefDiagnosisRelatedGroupODataService,
    private toastr: ToastrService,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.initializeRefDiagRelGrps()
    this.initializeGrid()

    const sm = this.route.snapshot.queryParams['successMessage']
    if (sm) {
      this.toastr.success(sm)
    }
  }

  addEntity(): void {
    this.router.navigate(['/system', 'bundledefinitions', 0])
  }

  editClicked(data) {
    const model = data as IBundleDefinition
    this.router.navigate(['/system', 'bundledefinitions', model.Id])
  }

  deleteClicked(data) {
    this.model = data as IBundleDefinition
    this.modalService
      .show(ConfirmModalComponent, {
        initialState: {
          title: `Delete Bundle Definiton?`,
          message: `Are you sure you want to delete the selected Bundle Definition?`
        }
      })
      .content.onClose.subscribe(userConfirm => userConfirm && this.deleteModel())
  }

  deleteModel(): void {
    this.odata
      .delete(this.model.Id)
      .exec()
      .subscribe(response => this.grid.getData())
  }
  private initializeRefDiagRelGrps() {
    this.refDiagRelGrpSvc
      .query()
      .orderBy('Description')
      .exec()
      .subscribe(response => {
        response.data.forEach(x =>
          this.refDiagRelGrps.push(new Option(x.Id, `${x.Description}`, x))
        )

        this.grid.setLookupFilterOptions('RefDiagnosisRelatedGroup.Id', this.refDiagRelGrps)
      })
  }

  initializeGrid() {
    this.grid.gridOptions.context = {
      canEdit: true,
      canDelete: true,
      editHandler: this.editClicked.bind(this),
      deleteHandler: this.deleteClicked.bind(this)
    }
    this.grid.frameworkComponents = {
      lookupFilter: LookupFilterComponent,
      boolFilter: BooleanFilterComponent
    }
    this.grid.gridOptions.columnDefs = [
      {
        headerName: '',
        field: 'Actions',
        pinned: 'left',
        width: 100,
        cellRenderer: ActionButtonsColumnRendererComponent
      },
      {
        headerName: 'CHI Bundle Definition ID',
        field: 'Id',
        width: 75,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agNumberColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'Name',
        field: 'Name',
        width: 100,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'EpisodeTypeName',
        field: 'EpisodeTypeName',
        width: 100,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'At Risk',
        field: 'AtRisk',
        width: 100,
        cellRenderer: GridWrapperComponent.BooleanRenderer(),
        filter: 'boolFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'Description',
        field: 'Description',
        width: 100,
        cellRenderer: GridWrapperComponent.TooltipRenderer(),
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      },
      {
        headerName: 'Diagnosis Related Group',
        field: 'RefDiagnosisRelatedGroup.Description',
        width: 60,
        filter: 'agTextColumnFilter',
        filterParams: { newRowsAction: 'keep' }
      }
    ]
    this.grid.defaultExpand = 'RefDiagnosisRelatedGroup'
    this.grid.odata = this.odata
  }
}
